import { render, staticRenderFns } from "./couponVertifyCodeRecord.vue?vue&type=template&id=d4bd910a&scoped=true"
import script from "./couponVertifyCodeRecord.vue?vue&type=script&lang=ts"
export * from "./couponVertifyCodeRecord.vue?vue&type=script&lang=ts"
import style0 from "./couponVertifyCodeRecord.vue?vue&type=style&index=0&id=d4bd910a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd910a",
  null
  
)

export default component.exports